export default __webpack_public_path__ + "static/media/roadmap.77cf2d97.png";